import * as matchDirective from './match.directive';
import * as validateInputDirective from './validateInput.directive';
import * as validationService from './validation.service';
import * as $gzRegexValidator from './regexValidator.service';
import * as gzRegexValidator from './regexValidator.directive';
import * as gzUniqueValidator from './uniqueValidator.directive';

import messagesRun from './messages.run';

export default angular.module('gazelle.components.validation', [
  'rhino.core',
  'ngMessages',
])
  .directive(matchDirective.name, matchDirective.default)
  .directive(validateInputDirective.name, validateInputDirective.default)
  .directive(gzRegexValidator.name, gzRegexValidator.default)
  .directive(gzUniqueValidator.name, gzUniqueValidator.default)
  .service(validationService.name, validationService.default)
  .factory($gzRegexValidator.name, $gzRegexValidator.default)
  .run(messagesRun)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/validation/validation.module.js